module.exports = __webpack_public_path__ + "a62d4d0ab1bc7d21d6b98e23f403d1e3.svg";